import { useEffect, useMemo, useState } from 'react';
import { Alert, Box, Tab, Tabs } from '@mui/material';
import PageContainer from 'src/pages/components/PageContainer';
import SkeletonLoad from 'src/pages/components/SkeletonLoad';
import {
  createEezyguardClient,
  getCompanyPublicLink,
} from 'src/apis/eezyguard';
import { isUserCompany } from 'src/utils/auth';
import EezyGuardDashboard from 'src/pages/components/eezyguard/EezyGuardDashboard';
import EezyGuardOccurrenceList from 'src/pages/components/eezyguard/EezyGuardOccurrenceList';
import LinkQrPanel from 'src/pages/components/eezyguard/LinkQrPanel';
import CompanyEmailsTab from 'src/pages/components/eezyguard/CompanyEmailsTab';
import EezyGuardLanding from './EezyGuardLanding';

export default function EezyGuardCompanyPage(): JSX.Element {
  const [loading, setLoading] = useState(true);
  const [enabled, setEnabled] = useState(false);
  const [hasAccess, setHasAccess] = useState(true);
  const [slug, setSlug] = useState<string | null>(null);
  const [enabledAt, setEnabledAt] = useState<string | null>(null);
  const [tab, setTab] = useState(0);
  const [error, setError] = useState('');
  const client = useMemo(() => createEezyguardClient('company'), []);

  useEffect(() => {
    let active = true;
    getCompanyPublicLink()
      .then((res) => {
        if (!active) return;
        setEnabled(Boolean(res.enabled));
        setHasAccess(Boolean(res.has_access));
        setSlug(res.public_slug);
        setEnabledAt(res.enabled_at);
      })
      .catch(() => active && setEnabled(false))
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, []);

  return (
    <PageContainer title="EezyLine" error={error} guard={isUserCompany}>
      {loading ? (
        <SkeletonLoad variant="cards" rows={3} />
      ) : !enabled ? (
        <EezyGuardLanding />
      ) : !hasAccess ? (
        <Alert severity="info">
          Seu usuário não tem acesso ao painel do EezyLine. O acesso é exclusivo de
          usuários do tipo &quot;Administrador da empresa&quot;.
        </Alert>
      ) : (
        <Box display="flex" flexDirection="column" gap={2}>
          <LinkQrPanel slug={slug} enabled={enabled} enabledAt={enabledAt} />
          <Tabs value={tab} onChange={(_, v) => setTab(v)}>
            <Tab label="Dashboard" />
            <Tab label="Ocorrências" />
            <Tab label="Emails" />
          </Tabs>
          {tab === 0 && <EezyGuardDashboard client={client} onError={setError} />}
          {tab === 1 && <EezyGuardOccurrenceList scope="company" onError={setError} />}
          {tab === 2 && <CompanyEmailsTab />}
        </Box>
      )}
    </PageContainer>
  );
}
